import { useEffect } from "react";

// Both rules use ▄ (lower-half block). Measured by pixel-scanning the rendered
// console output across several candidates, ▄/▄ gives the most even gap above vs
// below "NEW CAR" (the art is slightly top-heavy from the overscores, so a
// perfectly equal gap isn't achievable with whole-cell rules; ▄/▄ was closest).
const BANNER = String.raw`
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
 _   _ _______        __   ____    _    ____
| \ | | ____\ \      / /  / ___|  / \  |  _ \
|  \| |  _|  \ \ /\ / /  | |     / _ \ | |_) |
| |\  | |___  \ V  V /   | |___ / ___ \|  _ <
|_| \_|_____|  \_/\_/     \____/_/   \_\_| \_\
▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄
              "BIRD" is the word
`;

/**
 * Print the New Car team's console banner once on the client, on mount. It is a
 * deliberately visible signature for anyone who opens the browser console — a
 * friendly hint, not hidden. Returns `null`; it renders nothing. The banner only
 * prints in the browser (the log lives in an effect, so it never runs during
 * SSR), and only once per page load.
 */
export function ConsoleBanner() {
	useEffect(() => {
		console.log(BANNER);
	}, []);

	return null;
}
